import { errorIco } from "Assets";
import { EMatButton } from "Components";
import { useTranslation } from "react-i18next";
import { ReactSVG } from "react-svg";

const FailSummary = ({ onBackToOperate, onClickEdit }: any) => {
  const [t] = useTranslation();

  return (
    <div className="fail-summary-container">
      <ReactSVG src={errorIco} />
      <h1>{t("operation:futures.summary.no-operations")}</h1>
      <div className="buttons-container">
        <EMatButton type="primary" onClick={onBackToOperate}>
          {t("operation:futures.summary.go-to-operate")}
        </EMatButton>
        <EMatButton type="text" id="edit" onClick={onClickEdit}>
          {t("common:actions.edit")}
        </EMatButton>
      </div>
    </div>
  );
};

export default FailSummary;
